import { useEffect, useState } from "react";

export function useDebounced<T>(value: T, delay = 300): T {
  const [debounced, setDebounced] = useState<T>(() => value);

  useEffect(() => {
    const timeoutId = window.setTimeout(() => {
      setDebounced(() => value);
    }, delay);

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [value, delay]);

  return debounced;
}
